import * as React from 'react';

function SvgContactMail(props) {
  return (
    <svg width="3em" height="3em" viewBox="0 0 36.673 28.815" {...props}>
      <path
        data-name="unread mail"
        d="M33.4 0H3.276a3.289 3.289 0 00-2.157.812.638.638 0 00-.107.07.333.333 0 00-.025.037 3.153 3.153 0 00-.985 2.283v22.411a3.243 3.243 0 003.274 3.2H33.4a3.243 3.243 0 003.274-3.2V3.2A3.243 3.243 0 0033.4 0zM3.276 1.281H33.4a1.99 1.99 0 01.751.147L18.324 16.904 2.504 1.437a1.988 1.988 0 01.77-.156zM1.311 25.612V3.2a1.862 1.862 0 01.235-.892l12.249 11.977-12.334 12.06a1.875 1.875 0 01-.151-.733zM33.4 27.533H3.276a1.974 1.974 0 01-.93-.24l12.377-12.1 2.962 2.9c.011.01.026.014.037.024a.644.644 0 001.238-.021h.005l2.962-2.9 12.386 12.11a1.974 1.974 0 01-.913.228zm1.964-1.921a1.869 1.869 0 01-.158.754L22.852 14.287 35.119 2.292a1.868 1.868 0 01.245.91z"
        fill="#eea804"
      />
    </svg>
  );
}

export default SvgContactMail;
